// eslint-disable-next-line @typescript-eslint/naming-convention
export enum NOTICE_TYPES {
    // 业务消息
    BUSSINESS_MESSAGE = 1,
    // 系统消息
    SYSTEM_MESSAGE = 2,
    // 代运营解约
    THIRD_CANCEL = 3,
    //退款审核
    REFUND_REVIEW = 4,
    // 跳转类型
    GOTO_RUL = 5,
}
export interface MessageItem {
    id: string;
    noticeType: NOTICE_TYPES;
    pubdate: string;
    readSign: boolean;
    title: string;
    mainTitle: string;
}
export interface MessageRes {
    messageList: MessageItem[];
    pageNum: number;
    total: number;
}

export enum MessageType {
    OPERATIONAL = 1,
    PLATFORM = 2,
}

export interface ListCommenReq {
    pageNum: number;
    pageSize: number;
    msgType: MessageType;
}
export interface IListProps {
    msgType: MessageType;
}
